import { Component, computed, effect, EventEmitter, inject, Output, Signal } from '@angular/core';
import { CarFilters, IMapBounds } from 'common_library';
import { _ } from 'src/app/consts';
import { CoreService } from 'src/app/services/core.service';
import { CpoFilterOptionsService } from 'src/app/services/cpo-filter-options.service';
import { StoreService } from 'src/app/services/utils/store.service';
import { AuthService } from '../../services/auth/auth.service';
import { MainStateService } from 'src/app/services/state/app-main-state.service';
import { AppService } from 'src/app/services/app.service';
import { OperatorFilterSelection } from 'src/app/components/filter-cpo-selector/filter-cpo-selector.component';

export const DEFAULT_FILTER: CarFilters = {
  quick: [],
  carId: null,
  plugs: ["Type1", "Type2", "Type2s", "Type3a", "Type3c", "CHAdeMO", "Combo1", "Combo2"],
  range: { lower: 2, upper: 350 },
  cpos: [],
  operatorIds: [],
};

@Component({
  selector: 'yf-filter-modal',
  templateUrl: './filter.page.html',
  styleUrls: ['./filter.page.scss'],
  standalone: false
})
export class FilterPage {
  $filterState: Signal<CarFilters> = this.mainStateService.$filterButtonState;
  $resolvedFilter = computed(() => this.$filterState() || DEFAULT_FILTER);
  appService = inject(AppService);
  $text = this.appService.$text;
  isDefaultFilter = computed(() => this.areFiltersEqual(this.$resolvedFilter(), DEFAULT_FILTER));

  cpos = this.cpoFilterOptionsService.$options;
  @Output() filterChange = new EventEmitter<IMapBounds>();

  constructor(
    public auth: AuthService,
    public CS: CoreService,
    private store: StoreService,
    private mainStateService: MainStateService,
    private cpoFilterOptionsService: CpoFilterOptionsService,
    ) {
    effect(() => {
      const state = this.$filterState();
      if (!state) return;
      this.store.set(_.SELECTED_FILTER, state);
    })
  }

  async updateModel(event: string[] | { lower: number, upper: number }, type: string) {
    let buttonState: CarFilters = this.mainStateService.getFilterButtonState() || DEFAULT_FILTER;
    this.mainStateService.setFilterButtonState({ ...buttonState, [type]: event });
    this.filterChange.emit();
  }

  async updateOperatorFilters(event: OperatorFilterSelection) {
    let buttonState: CarFilters = this.mainStateService.getFilterButtonState() || DEFAULT_FILTER;
    this.mainStateService.setFilterButtonState({
      ...buttonState,
      cpos: event.cpos,
      operatorIds: event.operatorIds,
    });
    this.filterChange.emit();
  }

  resetFilters() {
    const resetValue: CarFilters = {
      quick: [],
      carId: null,
      plugs: [...DEFAULT_FILTER.plugs],
      range: { ...DEFAULT_FILTER.range },
      cpos: [...DEFAULT_FILTER.cpos],
      operatorIds: [...DEFAULT_FILTER.operatorIds],
    };
    this.mainStateService.setFilterButtonState(resetValue);
    this.filterChange.emit();
  }

  private areFiltersEqual(current: CarFilters, base: CarFilters): boolean {
    if (!current) {
      return true;
    }
    return this.sameArray(current.quick, base.quick)
      && this.sameArray(current.plugs, base.plugs)
      && this.sameArray(current.cpos, base.cpos)
      && this.sameArray(current.operatorIds, base.operatorIds)
      && current.carId === base.carId
      && current.range?.lower === base.range.lower
      && current.range?.upper === base.range.upper;
  }

  private sameArray(first: string[] = [], second: string[] = []): boolean {
    if (first.length !== second.length) {
      return false;
    }
    const a = [...first].sort();
    const b = [...second].sort();
    return a.every((el, idx) => el === b[idx]);
  }
}
